import { combineReducers } from "redux";
import unapprovedReportsTable from "./unapprovedReportsTable";
import approvedReportsTable from "./approvedReportsTable";

export default combineReducers({
    unapprovedReportsTable,
    approvedReportsTable
});
